/*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

const ESCAPE_MAP: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

const escapeHtml = (s: string): string =>
  s.replace(/[&<>"']/g, (c) => ESCAPE_MAP[c]);

export type CustomSlotVars = Record<string, string | undefined>;

/**
 * Substitute `{{name}}` placeholders in an admin-defined HTML template with
 * runtime values from the page (question_id, answer_id, tags, ...). Variable
 * values are HTML-escaped to prevent untrusted content (question titles, tag
 * names, etc.) from breaking out of attributes or injecting markup. The
 * template itself is treated as trusted admin HTML.
 */
export function renderCustomSlot(
  template: string,
  vars: CustomSlotVars,
): string {
  if (!template) return '';
  return template.replace(/\{\{(\w+)\}\}/g, (_, key: string) =>
    escapeHtml(vars[key] ?? ''),
  );
}
